const BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL;

export interface UserDailyCount {
  date: string;
  count: number;
}

class AdminProvider {
  private async request<T>(path: string, options?: RequestInit): Promise<T> {
    const res = await fetch(`${BASE_URL}${path}`, {
      ...options,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });

    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
      throw new Error("Unauthorized");
    }

    if (!res.ok) {
      const text = await res.text().catch(() => "Unknown error");
      throw new Error(text || `HTTP ${res.status}`);
    }

    const text = await res.text();
    try {
      return JSON.parse(text) as T;
    } catch {
      return text as unknown as T;
    }
  }

  getUsersHistory(days: number = 365): Promise<UserDailyCount[]> {
    return this.request<UserDailyCount[]>(
      `/v1/admin/users/history?days=${days}`,
    );
  }

  getUsersHistoryAll(): Promise<UserDailyCount[]> {
    return this.request<UserDailyCount[]>(`/v1/admin/users/history`);
  }

  getUsersCurrent(): Promise<number> {
    return this.request<number>(`/v1/admin/users/current`);
  }
}

export const adminProvider = new AdminProvider();
